export enum ApiVersion {
	v10 = 'v1.0',
	v11 = 'v1.1',
	v12 = 'v1.2',
	v13 = 'v1.3',
	v20 = 'v2.0',
}

export default ApiVersion;
